import axios from 'axios'

export default {
    getFreeSlots({ dateFrom, dateTo, availabilityOfferId, offerCategoryIds }) {
        return axios.post('/public-calendar-event/free-slots', { dateFrom, dateTo, availabilityOfferId, offerCategoryIds })
    },

    getFreeSlotsWithAuth({ dateFrom, dateTo, availabilityOfferId, offerCategoryIds, freeSchedule, rescheduleCalendarEventId }) {
        return axios.post('/calendar-event/free-slots', {
            dateFrom,
            dateTo,
            availabilityOfferId,
            offerCategoryIds,
            freeSchedule,
            rescheduleCalendarEventId,
        })
    },

    createReservation({
        date,
        availabilityOfferId,
        from,
        description,
        offerCategoryIds,
        freeSchedule,
        userId,
        customReservation = false,
    }) {
        return axios.post('/calendar-event/create-open-event', {
            date,
            availabilityOfferId,
            from,
            description,
            offerCategoryIds,
            freeSchedule,
            userId,
            customReservation,
        })
    },

    getReservationsMade(data) {
        return axios.post('/calendar-event/made-filter', data)
    },

    getReservationsReceived(data) {
        return axios.post('/calendar-event/received-filter', data)
    },

    getReservationsReceivedPdf(data) {
        return axios({
            method: 'post',
            url: '/calendar-event/received-filter-pdf',
            data: data,
            responseType: 'blob',
            contentType: 'application/pdf',
        })
    },

    getMySchedule({ dateFrom, dateTo, excludeOfferIds, excludeCompanyIds, performerId }) {
        return axios.post('/calendar-event/working-schedule', {
            dateFrom,
            dateTo,
            excludeOfferIds,
            excludeCompanyIds,
            performerId,
        })
    },

    getById(id) {
        return axios.get(`/calendar-event/${id}`)
    },

    changeReservationStatus({ calendarEventId, status, moderatorNote }) {
        return axios.post('/calendar-event/change-event-status', { calendarEventId, status, moderatorNote })
    },

    reschedule({
        date,
        calendarEventId,
        availabilityOfferId,
        from,
        moderatorNote,
        offerCategoryIds,
        freeSchedule,
        customReservation,
    }) {
        return axios.post('/calendar-event/reschedule-event', {
            date,
            calendarEventId,
            availabilityOfferId,
            from,
            moderatorNote,
            offerCategoryIds,
            freeSchedule,
            customReservation,
        })
    },

    makeSlotUnavailable(date, availabilityOfferId, from) {
        return axios.post('/calendar-event/create-unavailable-event', { date, availabilityOfferId, from })
    },

    finishEarly(calendarEventId, allowOverlapAfterMinutes) {
        return axios.post('/calendar-event/allow-overlap-event', { calendarEventId, allowOverlapAfterMinutes })
    },

    addReservationNote(data) {
        return axios.put('/calendar-event/update-moderator-note', data)
    },

    updateReservationPrice(data) {
        return axios.put('/calendar-event/update-paid-amount', data)
    },
}
